import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Button } from 'ui';
import { getApiErrorMessage } from 'utils/getApiErrorMessage';

import {
  useConfirmPersonalDataDecision,
  usePreviewPersonalDataDecision,
} from 'hooks/usePersonalDataChange';

import classes from './PersonalDataPages.module.scss';

function formatPerson(data: Record<string, unknown> | undefined): string {
  if (!data) return ' - ';
  return [data.surname, data.name, data.patronymic].filter(Boolean).join(' ') || ' - ';
}

export const PersonalDataConfirmPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  const [started, setStarted] = useState(false);

  const preview = usePreviewPersonalDataDecision(token);
  const confirm = useConfirmPersonalDataDecision();

  useEffect(() => {
    if (!token || started) return;
    setStarted(true);
    confirm.mutate(token, {
      onSuccess: (data) => {
        navigate(`/personal-data/otp?request_id=${data.request_id}`, { replace: true });
      },
    });
  }, [token, started, confirm, navigate]);

  if (!token) {
    return (
      <section className={classes.wrapper}>
        <div className={classes.card}>
          <h1 className={classes.title}>Неверная ссылка</h1>
          <p className={classes.text}>Ссылка подтверждения не содержит токен.</p>
        </div>
      </section>
    );
  }

  if (confirm.isError) {
    return (
      <section className={classes.wrapper}>
        <div className={classes.card}>
          <h1 className={classes.title}>Не удалось подтвердить</h1>
          <p className={`${classes.text} ${classes.error}`}>
            {getApiErrorMessage(confirm.error, 'Ссылка недействительна или истекла')}
          </p>
          <Button onClick={() => navigate('/login')}>На главную</Button>
        </div>
      </section>
    );
  }

  const proposed = preview.data?.proposed as Record<string, unknown> | undefined;
  const current = preview.data?.current as Record<string, unknown> | undefined;

  return (
    <section className={classes.wrapper}>
      <div className={classes.card}>
        <h1 className={classes.title}>Подтверждение изменений</h1>
        {confirm.isPending ? (
          <p className={classes.text}>Обрабатываем запрос и отправляем код на почту...</p>
        ) : (
          <p className={classes.text}>Перенаправляем на ввод кода...</p>
        )}
        {(current || proposed) && (
          <div className={classes.changes}>
            <div>Сейчас: {formatPerson(current)}</div>
            <div>Станет: {formatPerson(proposed)}</div>
          </div>
        )}
      </div>
    </section>
  );
};
